import { useEffect, useState } from 'react';
import infoIcon from '@assets/information.svg';
import { useFormContext } from '@context/FormContext';
import { useTexts } from 'utils/useTexts';

interface DisqualifiedMessage {
  message: string;
  tooltip: string;
}

export const DisqualifiedList = () => {
  const { t } = useTexts();
  const { licensePlateInfoForm, licensePlateInfoResponse, manualLicensePlateInfoForm } = useFormContext();
  const [disqualifiedMessages, setDisqualifiedMessages] = useState<DisqualifiedMessage[]>([]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const messages: DisqualifiedMessage[] = [];

    if (
      licensePlateInfoForm.estimatedMileageRange === 'Over 150,000 miles' ||
      manualLicensePlateInfoForm.estimatedMileage === 'Over 150,000 miles'
    ) {
      messages.push({
        message: t('disqualified.over150kMiles.message'),
        tooltip: t('disqualified.over150kMiles.tooltip'),
      });
    }

    if (
      (licensePlateInfoResponse?.year && licensePlateInfoResponse?.year !== '' && licensePlateInfoResponse?.year !== undefined) ||
      (manualLicensePlateInfoForm.year && manualLicensePlateInfoForm.year !== '' && manualLicensePlateInfoForm.year !== undefined)
    ) {
      if (
        Number(licensePlateInfoResponse?.year) < currentYear - 10 ||
        Number(manualLicensePlateInfoForm.year) < currentYear - 10
      ) {
        messages.push({
          message: t('disqualified.vehicleIsOver10.message'),
          tooltip: t('disqualified.vehicleIsOver10.tooltip'),
        });
      }
    }

    if (messages.length > 0) {
      setDisqualifiedMessages(messages);
    }
  }, [manualLicensePlateInfoForm.year, manualLicensePlateInfoForm.estimatedMileage]);

  return (
    <div className="iLendingCDX-disqualifiedList">
      {disqualifiedMessages.map((item, index) => (
        <span
          key={index}
          className="iLendingCDX-disqualifiedItem"
        >
          {item.message}
          <div className="iLendingCDX-tooltipContainer">
            <img
              src={infoIcon}
              alt="info"
              className="iLendingCDX-infoIcon"
            />
            <div className="iLendingCDX-tooltip">{item.tooltip}</div>
          </div>
        </span>
      ))}
    </div>
  );
};
